<template>
  <div class="form-group select year-selector">
    <AppSelect
      v-model="selected"
      :options="years"
      :select2-options="select2Options"
    ></AppSelect>
  </div>
</template>

<script>
export default {
  name: 'AppYearPicker',
  props: {
    startYear: {
      default: () => moment().subtract(1, 'year').year(),
    },
    stopYear: {
      default: () => moment().add(1, 'year').year(),
    },
    value: {
      default: () => moment().year(),
    },
  },
  data() {
    return {
      select2Options: {
        allowClear: false,
        multiple: false,
        templateResult: this.yearTemplate,
        width: '100%',
      },
    };
  },
  computed: {
    years() {
      const years = [];

      for (let y = this.startYear; y <= this.stopYear; y++) {
        const year = moment(`${y}`, 'YYYY');
        const yearBeginning = moment(`${y}-01-01`);
        const yearEnd = moment(`${y}-12-31`);

        years.push({
          id: year.year(),
          text: year.year(),
          description: `${TimeUtils.format_date(yearBeginning)} -  ${TimeUtils.format_date(yearEnd)}`,
        });
      }

      return years;
    },
    selected: {
      get() {
        return this.value;
      },
      set(newYear) {
        this.$emit('input', newYear);
      },
    },
  },
  methods: {
    yearTemplate(state, _container) {
      return $(`
        <span>
          <span>${state.text}</span>
          <sub class="description">${state.description}</sub>
        </span>`);
    },
  },
};
</script>
